import ChangePassword from "common/components/ChangePassword/ChangePassword";
import Dashboard from "components/dashboard/Dashboard";
import ListOfValues from "components/listOfValues/ListOfValues";
import ManageObservations from "components/master/ManageObservations/ManageObservations";
import ManagePolicies from "components/master/ManagePolicies/ManagePolicies";
import ManageSchoolList from "components/master/ManageSchool/Schools/ManageSchoolList";
import { Route } from "react-router-dom";
// import Teachers from "components/Users/Teachers/Teachers";
import ManageAnnualPlan from "components/academicPlan/AnnualPlan/ManageAnnualPlan";
import ManageLessonPlan from "components/academicPlan/LessonPlans/ManageLessonPlan";
import ManageUnitPlan from "components/academicPlan/UnitPlan/ManageUnitPlan";
import AcademicPlanList from "components/academicPlanDetails/AcademicPlanList";
import AnnualPlanDetails from "components/academicPlanDetails/AnnualPlan/AnnualPlanDetails";
import LessonPlanDetails from "components/academicPlanDetails/LessonPlan/LessonPlanDetails";
import TierPlanDetails from "components/academicPlanDetails/TierPlan/TierPlanDetails";
import UnitPlanDetails from "components/academicPlanDetails/UnitPlan/UnitPlanDetails";
import ManageGoalReviewConfigurationList from "components/goals/configuration/ManageGoalReviewConfigurationList";
import ManageReviewSetGoal from "components/goals/review/ManageReviewSetGoal";
import ManageSetGoal from "components/goals/setup/ManageSetGoal";
import ManageClassesDetails from "components/master/ManageSchool/Class/ManageClassesDetails";
import ManageSchoolDetails from "components/master/ManageSchool/Classes/ManageClasses";
import ManageRolesDetails from "components/Users/ManageTeachers/ManageRoles";
import TeachersDetails from "components/Users/ManageTeachers/StaffDetails";
import Roles from "components/Users/Roles/Roles";

const MainContent = () => {
  return (
    <>
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/auth/reset-password" component={ChangePassword} />
      <Route path="/system-configurations/lov" component={ListOfValues} />
      <Route path="/master-data/policies" component={ManagePolicies} />
      <Route path="/master-data/observations" component={ManageObservations} />
      {/* <Route path="/users/teachers" component={Teachers} /> */}
      <Route
        exact
        path="/goals/reviewers/configuration"
        component={ManageGoalReviewConfigurationList}
      />
      <Route exact path="/goals/set" component={ManageSetGoal} />
      <Route path="/goals/set/review" component={ManageReviewSetGoal} />
      <Route path="/change-password" component={ChangePassword} />
      <Route path="/academic-plans/annual-plans" component={ManageAnnualPlan} />
      <Route path="/academic-plans/unit-plans" component={ManageUnitPlan} />
      <Route path="/academic-plans/lesson-plans" component={ManageLessonPlan} />
      <Route path="/system-configurations/roles" component={Roles} />

      {/* School Section */}
      <Route exact path="/schools" component={ManageSchoolList} />
      <Route path="/schools/:id" component={ManageSchoolDetails} />
      <Route exact path="/classes/:id" component={ManageClassesDetails} />

      {/* teachers Section */}
      <Route
        exact
        path="/users"
        render={() => <TeachersDetails planName="STAFF" />}
      />
      <Route path="/users/:id" component={ManageRolesDetails} />

      {/* Academic Plan Section */}
      <Route
        path="/annual-plans"
        render={() => <AcademicPlanList planName="ANNUAL_PLAN" />}
      />
      <Route
        path="/tier-plans"
        render={() => <AcademicPlanList planName="TIER_PLAN" />}
      />
      <Route
        path="/unit-plans"
        render={() => <AcademicPlanList planName="UNIT_PLAN" />}
      />
      <Route
        path="/lesson-plans"
        render={() => <AcademicPlanList planName="LESSON_PLAN" />}
      />
      <Route path="/annual-plan/:id" component={AnnualPlanDetails} />
      <Route path="/tier-plan/:id" component={TierPlanDetails} />
      <Route path="/unit-plan/:id" component={UnitPlanDetails} />
      <Route path="/lesson-plan/:id" component={LessonPlanDetails} />
    </>
  );
};

export default MainContent;
